import React, { Component } from 'react';
import {Link} from 'react-router-dom';
class Slider extends Component {
  constructor() {
    super();
    this.state = {
    };
  }


  componentDidMount() {
       }


  render() {
    return (
         <div className="container-fluid p-0 dis_flex">

     <div className="left_con">
            <div className="owl-carousel header-carousel position-relative">
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-0.png" alt=""/>
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-1.png" alt="" />
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-3.png" alt="" />
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-4.png" alt="" />
                    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center slider-div-1">
                        <div className="container">
                            <div className="row justify-content-start">
                                <div className="col-10 col-lg-8">
                                    <h2 className="display-3 text-white animated slideInDown mb-4">Empowering Business by Laws</h2>

                                    <Link to="/freeConsultation" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Free Consultation</Link>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="owl-carousel-item position-relative">
                    <img className="img-fluid" src="./assets/img/slider/carousel-5.png" alt="" />
                </div>
            </div>
      </div>




        </div>
    );
  }
}

export default Slider;
